const styles = {
  button: {
    minWidth: 0,
    padding: '5px',
  },
  box: {
    padding: 0,
  },
};

export default styles;
